import React from 'react';
import { connect, useSelector } from 'react-redux';
import { Field, reduxForm, getFormValues } from 'redux-form';
import { SelectField } from '../../../../common/components/ReduxFormField';
import { Box, Button, ButtonBar, DatePicker } from '../../../../common/components';
import { generateReport } from '../../redux/accountActions';
import { Form, Col, Row, ControlLabel, FormGroup } from 'react-bootstrap';
import { required } from 'redux-form-validators';
import './WeeklyReports.scss';

const isRequired = required({ message: 'Required' });
const REPORTS = [{ label: 'AIG Screening Report', value: 'aig_screening:bespoke' }];

const WeeklyReports = ({ onGenerateReport, formValues, handleSubmit }) => {
  const generate = (values) => {
    onGenerateReport(values);
  };

  const { isGeneratingReport } = useSelector((state) => state.account);

  return (
    <Box>
      <Form onSubmit={handleSubmit(generate)}>
        <Row>
          <Col sm={12}>
            <h2 className="resource-name">Weekly Reports</h2>
          </Col>
        </Row>
        <Field
          name="report"
          label="Report"
          labelSize={2}
          smFieldSize={4}
          component={SelectField}
          options={REPORTS}
          validate={[isRequired]}
        />

        <FormGroup>
          <Col sm={2}>
            <ControlLabel>From Date</ControlLabel>
          </Col>
          <Col sm={4}>
            <div className={'date-group'}>
              <Field name="from_date" component={DatePicker} validate={[isRequired]} />

              <span className={'to-label'}>to</span>
              <Field
                name="to_date"
                minDate={formValues?.from_date}
                component={DatePicker}
                validate={[isRequired]}
              />
            </div>
          </Col>
        </FormGroup>
        <Row>
          <Col sm={12}>
            <ButtonBar>
              <Button
                className="pull-right"
                type="submit"
                label="Generate Report"
                isLoading={isGeneratingReport}
                bsStyle="primary"
              />
            </ButtonBar>
          </Col>
        </Row>
      </Form>
    </Box>
  );
};

const FORM_NAME = 'WeeklyReportsForm';

const form = reduxForm({ form: FORM_NAME })(WeeklyReports);
export default connect(
  (state) => ({
    formValues: getFormValues(FORM_NAME)(state),
  }),
  {
    onGenerateReport: generateReport,
  },
)(form);
